import React from "react";
import { Link } from "react-router-dom";

function Track() {
    return (
        <>
            {/* About Section */}
            <div className="breadcrumb-area about-bg">
                <div className="overlay"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="breadcrumb-title">
                                <h1>Latest News</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
 <div className="blog-area gray-bg section-padding">
        <div className="container">            
            <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="200ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Jan 21, 2024</span>
                                </div>                                
                            </div>
                            <div className="blog-title">
                                <h5>Five Importance logistics solutions for Parcel & Delivery Services </h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/1.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="blog-details.html">standard, </a>
                                    <a href="blog-details-2.html"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="blog-details.html" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="400ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Jan 07, 2024</span>
                                </div>
                               
                            </div>
                            <div className="blog-title">
                                <h5>Cargo Shipment on Ocean Freight Demands Frequently Costly</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/2.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="blog-details.html">standard, </a>
                                    <a href="blog-details-2.html"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="blog-details.html" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="600ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Dec 16, 2022</span>
                                </div>
                                
                            </div>
                            <div className="blog-title">
                                <h5>We believe in building long lasting our business relationships</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/3.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="blog-details.html">standard, </a>
                                    <a href="blog-details-2.html"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="blog-details.html" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="200ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Dec 16, 2022</span>
                                </div>
                                
                            </div>
                            <div className="blog-title">
                                <h5>We believe in building long lasting our business relationships</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/4.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="blog-details.html">standard, </a>
                                    <a href="blog-details-2.html"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="blog-details.html" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="400ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Dec 16, 2022</span>
                                </div>
                                
                            </div>
                            <div className="blog-title">
                                <h5>We believe in building long lasting our business relationships</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/5.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="blog-details.html">standard, </a>
                                    <a href="blog-details-2.html"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="blog-details.html" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp animated" data-wow-delay="600ms">
                    <div className="blog-wrap">
                        <div className="blog-content">
                            <div className="blog-meta">
                                <div className="blog-date">
                                    <span>Dec 16, 2022</span>
                                </div>
                                
                            </div>
                            <div className="blog-title">
                                <h5>We believe in building long lasting our business relationships</h5>
                            </div>
                            <div className="blog-img-wrap">
                                <div className="blog-img">
                                    <img src="assets/img/blog/6.jpg" alt=""/>
                                </div>
                                <div className="blog-cat">
                                    <a href="blog-details.html">standard, </a>
                                    <a href="blog-details-2.html"> express</a>
                                </div>
                            </div>
                            <div className="blog-desc">
                                <p>There are some reason Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem, facilis perferendis ipsam.</p>
                            </div>
                            <div className="blog-more">
                                <a href="blog-details.html" className="main-btn border-btn">Read More <i className="las la-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
                      
        </>
    );
}

export default Track;